import { render } from "./Environment.vue?vue&type=template&id=40f0a48a&scoped=true"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"

import "./Environment.vue?vue&type=style&index=0&id=40f0a48a&lang=scss&scoped=true"
import "./Environment.vue?vue&type=style&index=1&id=40f0a48a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f0a48a"]])

export default __exports__